// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:32em){.link-list[data-v-3f392896]{display:flex;flex-wrap:nowrap;overflow:auto}.link-list li a[data-v-3f392896]{display:block!important}}aside[data-v-3f392896]{background-color:#fff;margin-top:1.5rem;z-index:9}.box[data-v-3f392896]{margin-bottom:.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
